<template>
    <b-container fluid>
        <!-- <b-row class="mb-3">
            <b-col>
                <b-form-group label="Seleccione la forma de subir la foto">
                    <b-form-radio-group
                        id="btn-radios-1"
                        v-model="photoWay"
                        :options="[{text: 'Tomar foto', value: 'take'}, {text: 'Subir foto', value: 'upload'}]"
                        buttons
                        name="radios-btn-default"
                        button-variant="primary"
                        block
                        @change="onPhotoWayChange"
                    ></b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row> -->
        <!-- <b-row v-if="photoWay === 'take'">
            <b-col>
                <app-camera
                    v-model="photo"
                    ref="camera"
                ></app-camera>
                <app-web-cam-lite
                    v-model="photo"
                ></app-web-cam-lite> -->
        <!-- <app-web-cam
                    v-model="photo"
                    :multiple="false"
                ></app-web-cam> -->
        <!-- </b-col>
        </b-row> -->
        <b-row v-if="photoWay === 'upload'">
            <b-col>
                <b-row v-if="!!photo" class="mb-3">
                    <b-col>
                        <b-img :src="photo" style="max-width: 100%;"></b-img>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="10">
                        <b-form-file
                            placeholder="Seleccionar foto"
                            @change="onSelectFile"
                            ref="photoFile"
                        ></b-form-file>
                    </b-col>
                    <b-col>
                        <b-btn
                            size="sm"
                            variant="danger"
                            @click="clearPhotoFile"
                            v-if="!!photo"
                            flat
                            ><i class="fa fa-trash"></i
                        ></b-btn>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import WebCamLite from "@components/UI/Controls/WebCamLite/WebCamLite";
import WebCam from "@components/UI/Controls/WebCam/WebCam";
import usersRepository from "@repositories/users.repository";
import Camera from "@components/UI/Controls/Camera/Camera";
import { required } from "vuelidate/lib/validators";
export default {
    components: {
        appWebCamLite: WebCamLite,
        appWebCam: WebCam,
        appCamera: Camera
    },
    props: {
        selectedUser: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        photoWay: "upload",
        photo: ""
    }),
    validations: {
        photo: { required }
    },
    methods: {
        onPhotoWayChange(val) {
            this.photo = "";
            if (val === "upload") {
                this.$refs.camera.turnOff();
            } else if (val === "take") {
                this.$nextTick(() => this.$refs.camera.playVideo());
            }
        },
        onSelectFile(event) {
            if (event.target.files.length === 0) {
                this.photo = "";
                return;
            }
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onloadend = e => {
                this.photo = reader.result;
            };
            reader.readAsDataURL(file);
        },
        clearPhotoFile() {
            this.photo = "";
            this.$refs.photoFile.reset();
        },
        async savePhoto() {
            this.$v.$touch();

            if (this.$v.$invalid)
                return toastr.error("Debe tomar la foto o seleccionarla");

            const ur = { ...usersRepository };
            try {
                const { data } = await ur.updatePhoto(
                    this.selectedUser.id,
                    this.photo
                );
                this.$emit("photo-updated", data);
            } catch (err) {
                this.handleErrors(err);
            } finally {
                this.stopProcessing();
            }
        }
    }
};
</script>
